import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ProductoActividad } from '../../../_models/producto-actividad';
import { ProductoActividadService } from '../../../_services/producto-actividad.service';
import { NavService } from '../../../_services/_nav.service';
import { ConfirmationService } from 'primeng/api';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-producto-actividad-aliado-listado',
  templateUrl: 'producto-actividad-aliado-listado.component.html'
} )

export class ProductoActividadAliadoListadoComponent implements OnInit {

  @Input() producto: Producto;
  lisProductoActividad: ProductoActividad[] = [];
  columnas: any[];
  carTabla: boolean;
  proActividadSeleccionado: ProductoActividad;
  seccion = 'LISTADO';

  constructor( private proActividadServicio: ProductoActividadService,
               private navServicio: NavService,
               private location: Location,
               private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreSegmento', header: this.navServicio.buscarMensaje( 'PRODUCTOACTIVIDAD.LBL_SEGMENTO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.cargarListadoProductoActividad();
  }


  cargarListadoProductoActividad() {
    this.carTabla = true;
    this.lisProductoActividad = [];
    this.proActividadServicio.listadoPorProducto( this.producto.idProducto ).subscribe( listado => {
      this.lisProductoActividad = listado;
      this.carTabla = false;
    } );
  }

  cambiarHabilitado( proActividad: ProductoActividad ) {
    if ( !proActividad.indicadorHabilitado && this.producto.indicadorHabilitado && !this.lisProductoActividad.find( x => x.indicadorHabilitado ) ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
      proActividad.indicadorHabilitado = true;
    } else if ( !proActividad.indicadorHabilitado ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'actividades',
        accept: () => {
          this.carTabla = true;
          this.proActividadServicio.actualizar( proActividad ).subscribe( regActualizado => {
            this.navServicio.setMesage(2);
            this.carTabla = false;
          } );
        },
        reject: () => {
          proActividad.indicadorHabilitado = true;
        }
      } );
    } else {
      this.carTabla = true;
      this.proActividadServicio.actualizar( proActividad ).subscribe( regActualizado => {
        this.carTabla = false;
      } );
    }

  }

  regresar() {
    this.location.back();
  }

  crear() {
    this.proActividadSeleccionado = null;
    this.seccion = 'EDITAR';
  }

  ver( proActividad: ProductoActividad ) {
    this.proActividadSeleccionado = proActividad;
    this.seccion = 'DETALLE';
  }

  editar( proActividad: ProductoActividad ) {
    this.proActividadSeleccionado = proActividad;
    this.seccion = 'EDITAR';
  }

  cambioSeccion( evento: boolean ) {
    this.seccion = 'LISTADO';
    if ( evento ) {
      this.cargarListadoProductoActividad();
    }
  }

  actualizarListado(listado: ProductoActividad[]){
    this.lisProductoActividad = listado;
  }

}
